import * as React from 'react'
import styled from 'styled-components'
import { device } from '../../templates/displays/devices'
import crossed_circle_grey from '@/public/assets/icons/crossed_circle_grey.svg'
import no_image from '@/public/assets/icons/no_image.svg'

interface IStyle {
    $height?: string
}

const Rectangle = styled.div<IStyle>`
    width: 100%;
    height: ${(props) => (props.$height ? props.$height : '150px')};
    background-color: #f9f9f9;
    border: transparent;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media ${device.mobile} {
        height: ${(props) => (props.$height ? props.$height : '100px')};
    }
`

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Text = styled.div`
    font-size: 13px;
    color: #cfcfcf;
    padding-left: 10px;
    text-transform: uppercase;
    @media ${device.mobile} {
        font-size: 11px;
    }
`

const Logo = styled.img<{ $largeIcon?: boolean }>`
    width: ${(props) => (props.$largeIcon ? '22px' : '17px')};
    @media ${device.mobile} {
        width: ${(props) => (props.$largeIcon ? '18px' : '15px')};
    }
`

const LogoWrapper = styled.div<{ $largeIcon?: boolean }>`
    display: flex;
    align-items: center;
    width: ${(props) => (props.$largeIcon ? '22px' : '17px')};
    @media ${device.mobile} {
        width: ${(props) => (props.$largeIcon ? '18px' : '15px')};
    }
`

type IProps = {
    height?: string
    text?: string
    noImgIcon?: boolean
}

const NoDataRectangle: React.FunctionComponent<IProps> = (props) => {
    return (
        <Rectangle $height={props.height}>
            <Wrapper>
                <LogoWrapper $largeIcon={props.noImgIcon}>
                    <Logo
                        $largeIcon={props.noImgIcon}
                        src={
                            props.noImgIcon
                                ? no_image.src
                                : crossed_circle_grey.src
                        }
                    />
                </LogoWrapper>
                <Text>{props.text ? props.text : 'No data'}</Text>
            </Wrapper>
        </Rectangle>
    )
}

export default NoDataRectangle
